import React from 'react'
import { useTranslation } from 'react-i18next'
import { TransitOperationFormValues } from 'features/declaration/models/schemas/transitOperationFormSchema'
import useCodelist from 'features/declaration/codelist/api/useCodelist'
import FormCollapsibleColumn from 'components/p5/FormCollapsibleColumn'
import FormField from 'components/p5/FormField'
import FormSelect from 'components/p5/FormSelect'
import Input from 'components/p5/Input'
import useDeclarationFieldRequirements
  from 'features/declaration/form/components/useDeclarationFieldRequirements'

const scope = 'placeOfUnloading'

function PlaceOfUnloading() {
  const { t } = useTranslation()
  const [, countriesOptions] = useCodelist('COUNTRIES')

  const fieldRequirements = useDeclarationFieldRequirements<TransitOperationFormValues>('transitOperation', [
    scope,
    'placeOfUnloading.country',
    'placeOfUnloading.location',
  ])

  return (
    <section className="py-3">
      <FormCollapsibleColumn
        columnId="declaration-unloading-place"
        headingLabel={t('declaration.p5.placeOfUnLoading')}
        fieldRule={fieldRequirements[scope]}
      >
        <FormField
          labelKey="declaration.p5.nationality"
          fieldRule={fieldRequirements['placeOfUnloading.country']}
        >
          <FormSelect
            <TransitOperationFormValues>
            field="placeOfUnloading.country"
            labelKey="declaration.p5.nationality"
            options={countriesOptions}
            type="sync"
            fieldRule={fieldRequirements['placeOfUnloading.country']}
          />
        </FormField>
        <FormField
          labelKey="declaration.p5.placeOfUnloadingLocation"
          fieldRule={fieldRequirements['placeOfUnloading.location']}
        >
          <Input
            <TransitOperationFormValues>
            field="placeOfUnloading.location"
            labelKey="declaration.p5.placeOfUnloadingLocation"
            type="text"
            maxLength={35}
            fieldRule={fieldRequirements['placeOfUnloading.location']}
            placeholder={t('declaration.p5.placeOfUnloadingLocation')}
          />
        </FormField>
      </FormCollapsibleColumn>
    </section>
  )
}

export default PlaceOfUnloading
